export const sdsPrimitiveColor = {
  mono: {
    light: 'var(--sds-color-primitive-mono-light)',
    dark: 'var(--sds-color-primitive-mono-dark)'
  },
  pink: {
    '100': 'var(--sds-color-primitive-pink-100)',
    '200': 'var(--sds-color-primitive-pink-200)',
    '600': 'var(--sds-color-primitive-pink-600)',
    '700': 'var(--sds-color-primitive-pink-700)'
  },
  grey: {
    '50': 'var(--sds-color-primitive-grey-50)',
    '200': 'var(--sds-color-primitive-grey-200)',
    '300': 'var(--sds-color-primitive-grey-300)',
    '400': 'var(--sds-color-primitive-grey-400)',
    '500': 'var(--sds-color-primitive-grey-500)',
    '700': 'var(--sds-color-primitive-grey-700)'
  }
} as const;

export const sdsColor = {
  background: {
    brandSecondary: 'var(--sds-color-background-brand-secondary)',
    defaultDefault: 'var(--sds-color-background-default-default)',
    defaultDefaultHover: 'var(--sds-color-background-default-default-hover)',
    defaultSecondary: 'var(--sds-color-background-default-secondary)',
    defaultSecondaryHover:
      'var(--sds-color-background-default-secondary-hover)',
    defaultTertiary: 'var(--sds-color-background-default-tertiary)',
    neutralDefault: 'var(--sds-color-background-neutral-default)'
  },
  border: {
    brandSecondary: 'var(--sds-color-border-brand-secondary)',
    defaultDefault: 'var(--sds-color-border-default-default)'
  },
  text: {
    brandDefault: 'var(--sds-color-text-brand-default)',
    brandSecondary: 'var(--sds-color-text-brand-secondary)',
    defaultDefault: 'var(--sds-color-text-default-default)',
    defaultSecondary: 'var(--sds-color-text-default-secondary)',
    disabledDefault: 'var(--sds-color-text-disabled-default)',
    disabledOnDisabled: 'var(--sds-color-text-disabled-on-disabled)'
  }
} as const;

export const sdsRadius = {
  xSmall: 'var(--sds-radius-x-small)'
} as const;
